<template>
  <el-menu :default-active="onRoutes" unique-opened router>
    <template v-for="item in menuList">
      <el-menu-item :index="item.index" :key="item.index">
        <i class="icon"></i><span>{{ item.label }}</span>
      </el-menu-item>
    </template>
  </el-menu>
</template>

<script>
export default {
  data() {
    return {
      userType: localStorage.getItem('userType'),
      menuList: [
        // {
        //   label: "门店管理",
        //   index: "stores"
        // },
        // {
        //   label: "核销账号管理",
        //   index: "account"
        // },
        {
          label: "核销数据",
          index: "datalist"
        }
      ],
    };
  },
  computed:{
    onRoutes(){
      return this.$route.path.replace('/','');
    }
  },
};
</script>

<style scoped></style>
